'use strict';
const angular = require('angular');

import { Ids as ACTION_IDS } from '../../components/constants/action.constants';

export class LoginComponent {

    email;
    password;
    saving: boolean = false;
    $http: any;
    error = {
        hasError: false,
        msg: ''
    };

    errorCode = {
        0: 'Error while processing your request.',
        1: 'Password is empty.',
        2: 'Your account is locked.',
        3: 'Password is incorrect.',
        4: 'Adoddle does not have a valid session to activate for this user account. Please restart your browser and try signing in again.',
        5: 'Error while processing your request.',
        6: 'Error while processing your request.',
        7: 'Cookie not found.',
        8: 'Email is empty.',
        9: 'Password is empty.'
    };

    interval;
    $interval;
    Util;
    USP;

    constructor($rootScope, $http, $interval, Util) {
        this.USP = $rootScope.USP;
        this.email = this.USP.email;
        this.Util = Util;
        this.$http = $http;
        this.$interval = $interval;
        this.interval = $interval(() => { this.checkSessionTimeout(); }, 500);
    }

    checkSessionTimeout() {
        let sessionState = window.localStorage.getItem('sessionState');
        if (sessionState == 'Active') {
            this.$interval.cancel(this.interval);
            (<any>window).setsessionTimoutTimer();
            this['close']();
        }
    }

    login() {
        let self = this;
        this.saving = true;
        this.error.hasError = false;

        self.$http({
            'url': (<any>window).properties.service.commonApiUrl + ACTION_IDS.ACTIVATE_USER_SESSION,
            'method': 'POST',
            'data': {
                email: self.email,
                password: self.password,
                ASessionID: self.USP.aSessionId || ''
            },
            'headers': {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            'withCredentials': true,
            transformRequest: function (obj) {
                var str = [];
                for (var p in obj)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                return str.join("&");
            }
        }).then(data => {
            data = data.data;
            self.saving = false;
            if (data) {
                if (data.success || data.errorCode == 6) {
                    window.localStorage.setItem('sessionState', 'Active');
                    (<any>window).setsessionTimoutTimer();
                    try {
                        window.top && window.top.opener && window.top.opener.setSessionState && window.top.opener.setSessionState('sessionState', 'Active');
                    } catch(e) { }
                    this['close']();
                } else {
                    self.error.hasError = true;
                    self.error.msg = self.errorCode[data.errorCode];
                }
            }
        }, (response) => {
            self.saving = false;
            self.error.hasError = true;
            self.error.msg = self.errorCode[0];
        });
    }

    onEnter($event) {
        if ($event.keyCode == 13 && this.email && this.password) {
            this.login();
        }
    }

}

export default angular.module('directives.login', [])
    .component('login', {
        template: require('./login.html'),
        controller: LoginComponent,
        controllerAs: 'LoginCtrl',
        bindings: {
            close: '&'
        }
    }).name;



// WEBPACK FOOTER //
// ./client/components/login/login.component.ts